import { ReactNode } from 'react';
import { WishlistProvider } from './WishlistProvider.tsx';
import { QuickViewProvider } from './QuickViewProvider.tsx';
import { PropertyFiltersProvider } from './PropertyFiltersProvider.tsx';
import { ShareDialogProvider } from './ShareDialogProvider.tsx';

type ModalProvidersProps = {
  children: ReactNode;
};

export const ModalProviders = ({ children }: ModalProvidersProps) => (
  <WishlistProvider>
    <QuickViewProvider>
      <ShareDialogProvider>
        <PropertyFiltersProvider>{children}</PropertyFiltersProvider>
      </ShareDialogProvider>
    </QuickViewProvider>
  </WishlistProvider>
);
